/* eslint-disable */
import {propsDecorator, viewModelDecorator} from '@/js/common/Domain/Service/mixins/decorators';
import imageProxy from '@/js/common/Domain/Service/imageProxy';

import PopupWrapperView from '@/js/desktop/components/popup/PopupWrapper';
import '@/js/desktop/plugins/sliderPro/jquery.sliderPro.min';
import '@fr/pages/desktop/application/hotel/index/pageTopBlock/gallery/gallery.css';

import template from './roomInfoDgTemplate.html';
import './roomInfoDg.scss';

@propsDecorator({
    el: $('<div class="roomInfoDg__container"></div>'),
    events: {
        'click .js-go-to-tour-page': 'goTourPage',
    },
})

@viewModelDecorator({
    default: {
        tourPageUrl: null,
    },
})

export default class RoomInfoDg extends Backbone.Epoxy.View {
    initialize() {
        $(this.$el).on('click', '.sp-full-screen-button', () => {
            setTimeout(() => {
                /*
                * данный слушатель необходим чтобы после закрытия полноэкранного слайдера модальное окно выровнялось по центру
                * таймаут необходим чтобы дать окну открыться и событие открыитя полноэкранного режима не перебило события закрытия
                * */
                this.fullScreenEvents();
            }, 300);
        });
    }

    fullScreenEvents() {
        $(document).one('webkitfullscreenchange mozfullscreenchange fullscreenchange MSFullscreenChange', () => {
            if ((document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement !== null)) {
                $(window).trigger('resize');
            }
        });
    }

    initDg(gallery) {
        this.dg = new PopupWrapperView({
            el: this.$el,
            dialogClass: `roomInfoDg ${gallery ? 'roomInfoDg-gallery' : 'without-gallery'}`,
            width: gallery ? 960 : 600,
            showCallback: () => {
                this.dgIsOpen = true;
            },
            closeCallback: () => {
                this.dgIsOpen = true;
            },
        });
    }

    goTourPage() {
        if (this.viewModel.get('tourPageUrl')) {
            window.open(this.viewModel.get('tourPageUrl'));
        }
    }

    open(view = {}) {
        const room = view.model?.get('tour')?.get('room');
        const roomDescriptionData = room?.description;

        if (roomDescriptionData) {
            const objectTourProductForRender = view.model?.get('objectTourProductForRender');
            const slider = room?.photos?.length;

            this.viewModel.set({
                tourPageUrl: view.getBinding('tourPageUrl'),
            });
            this.initDg(slider);
            this.dg.$el.html(template({
                ...objectTourProductForRender,
                imageProxy,
            }));

            this.dg.show();
            if (slider) {
                this.initSlider();
            }
        }
    }

    initSlider() {
        this.dg.$el.find('.slider-pro').sliderPro({
            width: 319,
            arrows: true,
            buttons: false,
            waitForLayers: true,
            fade: false,
            autoplay: false,
            autoScaleLayers: false,
            imageScaleMode: 'cover',
            slideDistance: 5,
            fadeArrows: false,
            fullScreen: true,
            fadeFullScreen: false,
            height: 248,
            thumbnailWidth: 79,
            thumbnailHeight: 64,
            thumbnailsPosition: 'bottom',
        });
    }
}